// extracted by mini-css-extract-plugin
module.exports = {"error":"Asset_error__Bu33C"};